var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7643 7.67119L15.9258 3.12305V6.47082C15.9258 7.13583 16.4953 7.67119 17.2028 7.67119H20.7643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8756 1.9043H2.89418C2.18673 1.9043 1.61719 2.43966 1.61719 3.10467V25.2601C1.61719 25.9251 2.18673 26.4605 2.89418 26.4605H18.437C19.1445 26.4605 19.714 25.9251 19.714 25.2601V6.45244",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0709 0.875H2.0895C1.38204 0.875 0.8125 1.41037 0.8125 2.07537V24.2308C0.8125 24.8958 1.38204 25.4312 2.0895 25.4312H17.6324C18.3398 25.4312 18.9094 24.8958 18.9094 24.2308V5.42315",
    fill: "#F15642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0709 0.875H2.0895C1.38204 0.875 0.8125 1.41037 0.8125 2.07537V24.2308C0.8125 24.8958 1.38204 25.4312 2.0895 25.4312H17.6324C18.3398 25.4312 18.9094 24.8958 18.9094 24.2308V5.42315",
    stroke: "#F15642",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9088 5.42315L14.0703 0.875V4.22277C14.0703 4.88778 14.6399 5.42315 15.3473 5.42315H18.9088Z",
    fill: "#FFA99E",
    stroke: "#FFA99E",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53516 12.4814C4.04519 12.4079 4.58464 12.3711 5.15352 12.3711C5.88914 12.3711 6.44085 12.5182 6.80866 12.8125C7.17647 13.1018 7.36038 13.5236 7.36038 14.0777C7.36038 14.6907 7.18138 15.1542 6.82337 15.4681C6.47028 15.7819 5.94554 15.9388 5.24915 15.9388C4.96471 15.9388 4.73176 15.929 4.55031 15.9094V17.8147H3.53516V12.4814ZM4.55031 15.115C4.73667 15.1444 4.93774 15.1591 5.15352 15.1591C5.55075 15.1591 5.85236 15.0733 6.05833 14.9016C6.26921 14.7251 6.37465 14.475 6.37465 14.1513C6.37465 13.499 5.9676 13.1729 5.15352 13.1729C4.93283 13.1729 4.73176 13.1876 4.55031 13.2171V15.115Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.443 15.0561C12.443 15.9732 12.1978 16.6745 11.7074 17.16C11.2219 17.6455 10.5279 17.8882 9.62557 17.8882C9.10082 17.8882 8.61041 17.8515 8.15433 17.7779V12.4814C8.61041 12.4079 9.10082 12.3711 9.62557 12.3711C10.523 12.3711 11.217 12.6065 11.7074 13.0773C12.1978 13.5432 12.443 14.2028 12.443 15.0561ZM11.4646 15.0561C11.4646 13.8154 10.8688 13.195 9.67706 13.195C9.4907 13.195 9.32151 13.2097 9.16948 13.2391V17.0202C9.32151 17.0496 9.4907 17.0643 9.67706 17.0643C10.2754 17.0643 10.7216 16.9001 11.0159 16.5715C11.315 16.2429 11.4646 15.7378 11.4646 15.0561Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2764 12.4447H16.5352V13.2759H14.3062V14.6883H16.388V15.4828H14.3062V17.8147H13.2764V12.4447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.c4670dd812eaed34d099cdf6415750f3.svg";
export { ForwardRef as ReactComponent };